import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  LEAD_STATUS,
  LEAD_STATUSES,
} from '../../../../services/utilityFunctions';

export default function StatusColumn({ t, status }) {
  const statusClass = (() => {
    switch (status) {
      case LEAD_STATUS.IN_PROGRESS:
        return 'm-badge--accent';
      case LEAD_STATUS.NO_OWNER:
      case LEAD_STATUS.WAITING_OWNER:
        return 'm-badge--warning';
      case LEAD_STATUS.LOST:
        return 'm-badge--danger';
      case LEAD_STATUS.WON:
      default:
        return 'm-badge--success';
    }
  })();

  const badgeClass = cx(
    'rewards-badge',
    'm-badge',
    'm-badge--square',
    statusClass,
  );
  return (
    <div className={badgeClass}>
      {t(`challengeDetails_leadStatus_${status}`)}
    </div>
  );
}

StatusColumn.propTypes = {
  t: PropTypes.func.isRequired,
  status: PropTypes.oneOf(LEAD_STATUSES).isRequired,
};
